import { ProposalDomainData } from 'store/modules/proposal/proposalDomainModule';

export abstract class IStepController {
  abstract get isValid(): boolean;
  abstract completeStep(domainData: ProposalDomainData, catalogId?: string, domainHeaderId?: string): Promise<void>;
}
